import { RETAILER } from './../../../config';

const SHOPRITE_FREQUENTLY_ASKED_QUESTIONS = [
  {
    header: "What is Downtime Dollars?",
    body: [
      "Downtime Dollars is an interactive experience that pays you to watch videos and/or indicate preferences with your favorite brands. By offering your opinion on the various brands’ videos and images, you will be rewarded with savings that you can load onto your ShopRite Price Plus Club card. Once loaded, savings are automatically applied to your next order at ShopRite when you use your Price Plus Club card at checkout!  *Please note: You need to spend a $1.00 more than your Downtime Dollars reward in order to redeem. Downtime Dollars is available on ShopRite.com, which you can access via your mobile device, desktop computer, laptop computer, or tablet (see below for a list of supported browsers).",
    ]
  },
  {
    header: "Do I have to be a ShopRite Price Plus Club card member to use ShopRite Downtime Dollars?",
    body: [
      "Yes, you must have a ShopRite Price Plus Club card to participate as well as a ShopRite.com account.  If you do not have a card, you can get one at ShopRite.com, on the ShopRite app, or at the customer service counter in store. To set up a ShopRite.com profile, visit ShopRite.com.",
      "If you think you may have already applied for a Price Plus Club card or set up a ShopRite.com account in the past, but are unsure of how to access, please call 1-800 –ShopRite.",
    ]
  },
  {
    header: "How do I link my ShopRite Price Plus Club card number in Downtime Dollars?",
    body: [
      "All you have to do is log in to your ShopRite account on ShopRite.com and select Downtime Dollars, which can be found in the Save menu, under the More Savings tab. We will use your existing credentials to ensure the rewards earned are properly applied to your ShopRite Price Plus Club card.",
    ]
  },
  {
    header: "I have misplaced my ShopRite Price Plus Club Card. Can I still participate?",
    body: [
      "Yes. If you don't recall your account number, please contact 1-800-ShopRite to retrieve your existing ShopRite Price Plus Club card number.",
    ]
  },
  {
    header: "Does Downtime Dollars have access to any of my personal information?",
    body: [
      "No. The only information needed to participate in the Downtime Dollars program is your ShopRite Price Plus Club card. No other information is collected or stored.",
    ]
  },
  {
    header: "How do I earn rewards using Downtime Dollars?",
    body: [
      "Once you’ve accessed Downtime Dollars from ShopRite.com, you will have the opportunity to earn savings by interacting with various brands. You will watch quick 15-30 second videos, view images of products and offer your opinion on questions about them. All we need is a bit of your time and your opinion. It’s important to note that the savings you earn is not tied to a specific product!",
    ]
  },
  {
    header: "What type of content is displayed in Downtime Dollars?",
    body: [
      "Content presented includes, but is not limited to, selecting a favorite of two images, answering simple multiple choice questions or viewing and rating a short video. You earn savings each time you complete an experience with the selected brand(s). You are offering your opinion about the advertising presented to you, not about the product itself.",
    ]
  },
  {
    header: "How do I load Downtime Dollars to my ShopRite Price Plus Club card?",
    body: [
      "Downtime Dollars savings can be loaded to your ShopRite Price Plus Club card at pre-defined value tiers - $1, $3, $6, or $9 .  Once you reach each tier, a button will activate on the site allowing you to choose to load savings to your card or keep earning until the next tier. For example, if you earn $1 and do not load it to your card and keep earning, when you reach $3, $6, or $9 you can then choose to add to your card.",
      "Please note: once savings are added to your card, you will see the expiration date on the screen. The savings will no longer be available after the date listed.",
      "Also, once you load the savings to your card (no matter the tier), you MUST redeem those savings before you can load additional savings.",
      "Remember: you CAN keep earning savings with Downtime Dollars, you just can’t load them to your card until you use the savings already loaded.",
    ]
  },
  {
    header: "Where can I check the status of Downtime Dollars earned?",
    body: [
      "From the main Downtime Dollars screen, tap on the card icon in the top right hand corner of your screen.  This will navigate you to an Account screen, which provides information on a) earnings loaded to your ShopRite Price Plus Club card that is ready to spend, or b) progress towards your next $1, $3, $6 or $9 earning tier.",
    ]
  },
  {
    header: "How much money can I earn on the app?",
    body: [
      "The total savings available will vary week to week. The total savings you can earn at any given time appears at the top of the home (or “Earn”) screen. The savings you can earn from each specific advertiser appears at the bottom of each experience tile on the main feed.",
    ]
  },
  {
    header: "Do Downtime Dollars that I have loaded to my ShopRite Price Plus Club card expire?",
    body: [
      "Redemption periods for all Downtime Dollars earnings tiers are 30-60 days once they are loaded to your Price Plus Club card. The expiration date will be clearly displayed underneath the card image on the Downtime Dollars account screen.",
    ]
  },
  {
    header: "How are my savings redeemed?",
    body: [
      "Be sure you’ve loaded your savings to your Price Plus Club card before your ShopRite purchase. Then, present your ShopRite Price Plus Club card at checkout. Your Downtime Dollars savings balance will be applied to your current purchases and automatically deducted from your order total. Savings are not tied to specific products.*Please note: You need to spend a $1.00 more than your Downtime Dollars reward in order to redeem.",
    ]
  },
  {
    header: "Can I use my savings on ShopRite from Home orders?",
    body: [
      "Yes! Downtime Dollars can be applied to your ShopRite from Home orders like any other savings tool.",
    ]
  },
  {
    header: "Do Downtime Dollars earnings only apply to the brands with whom I've connected and interacted?",
    body: [
      "The money you have earned may be applied to any subsequent shopping trip you make at ShopRite stores or via ShopRite from Home, and will be applied to your order regardless of what is in your shopping basket as long as your order total is greater than your Downtime Dollars Savings, and you have not purchased excluded items.",
      "<strong>(see below for list of excluded items)</strong>",
    ]
  },
  {
    header: "Are any items excluded from Downtime Dollars Savings?",
    body: [
      "Yes!  Downtime Dollars may not be used towards the purchase of prescription medications, gift cards, gift certificates, postage stamp sales, money orders, money transfers, lottery tickets, bus tickets, fuel and metro passes, as well as milk, cigarettes, tobacco products and alcoholic beverages or any other items prohibited by law. Terms and conditions apply.",
    ]
  },
  {
    header: "Why don’t I see the products in Downtime Dollars in my local ShopRite?",
    body: [
      "Some of the products in Downtime Dollars are in development and may not be currently available for purchase.",
    ]
  },
  {
    header: "While completing a survey/watching a video/answering questions, I left the site. Now I can’t seem to find the experience again. Why?",
    body: [
      "Savings experiences are available on Downtime Dollars for different lengths of time – this is decided by the manufacturer. That specific experience you are looking for may have expired. We apologize for any inconvenience. However we have many other experiences in Downtime Dollars that offer savings, with new ones added frequently. Please check back often!",
    ]
  },
  {
    header: "Why am I still seeing experiences that I have already completed?",
    body: [
      "Downtime Dollars experiences may now include links to recipes, digital coupons and ShopRite from Home. To ensure convenient access to those links, experiences will remain in your feed for 30 days after you've completed them but you will only be paid once per experience; any subsequent visits to these experiences will not result in additional earnings.",
    ]
  },
  {
    header: "What browsers can I use for Downtime Dollars?",
    body: [
      "<li>Internet Explorer 11</li>",
      "<li>Edge Versions 12+</li>",
      "<li>Chrome Versions 58+</li>",
      "<li>Safari Version S10+</li>",
      "<li>FireFox Versions 53+</li>",
    ]
  },
  {
    header: "Who should I contact if I have issues or concerns with Downtime Dollars?",
    body: [
      "For assistance with the Downtime Dollars, please contact 1-800-ShopRite."
    ]
  },
];

const FRESHGROCER_FREQUENTLY_ASKED_QUESTIONS = [
    {
        header: "What is Downtime Dollars?",
        body: [
            "Downtime Dollars is an interactive experience that pays you to watch videos and/or indicate preferences with your favorite brands. By offering your opinion on the various brands’ videos and images, you will be rewarded with savings that you can load onto your TheFreshGrocer Price Plus Club card. Once loaded, savings are automatically applied to your next order at TheFreshGrocer when you use your Price Plus Club card at checkout!  *Please note: You need to spend a $1.00 more than your Downtime Dollars reward in order to redeem. Downtime Dollars is available on TheFreshGrocer.com, which you can access via your mobile device, desktop computer, laptop computer, or tablet (see below for a list of supported browsers).",
        ]
    },
    {
        header: "Do I have to be a TheFreshGrocer Price Plus Club card member to use TheFreshGrocer Downtime Dollars?",
        body: [
            "Yes, you must have a TheFreshGrocer Price Plus Club card to participate as well as a TheFreshGrocer.com account. If you do not have a card, you can get one at TheFreshGrocer.com, on the TheFreshGrocer app, or at the customer service counter in store. To set up a TheFreshGrocer.com profile, visit TheFreshGrocer.com.",
            "If you think you may have already applied for a Price Plus Club card or set up a TheFreshGrocer.com account in the past, but are unsure of how to access, please call 1-800 –TheFreshGrocer.",
        ]
    },
    {
        header: "How do I link my TheFreshGrocer Price Plus Club card number in Downtime Dollars?",
        body: [
            "All you have to do is log in to your TheFreshGrocer account on TheFreshGrocer.com and select Downtime Dollars, which can be found in the Save menu, under the More Savings tab. We will use your existing credentials to ensure the rewards earned are properly applied to your TheFreshGrocer Price Plus Club card.",
        ]
    },
    {
        header: "I have misplaced my TheFreshGrocer Price Plus Club Card. Can I still participate?",
        body: [
            "Yes. If you don't recall your account number, please contact 1-800-TheFreshGrocer to retrieve your existing TheFreshGrocer Price Plus Club card number.",
        ]
    },
    {
        header: "Does Downtime Dollars have access to any of my personal information?",
        body: [
            "No. The only information needed to participate in the Downtime Dollars program is your TheFreshGrocer Price Plus Club card. No other information is collected or stored.",
        ]
    },
    {
        header: "How do I earn rewards using Downtime Dollars?",
        body: [
            "Once you’ve accessed Downtime Dollars from TheFreshGrocer.com, you will have the opportunity to earn savings by interacting with various brands. You will watch quick 15-30 second videos, view images of products and offer your opinion on questions about them. All we need is a bit of your time and your opinion. It’s important to note that the savings you earn is not tied to a specific product!",
        ]
    },
    {
        header: "What type of content is displayed in Downtime Dollars?",
        body: [
            "Content presented includes, but is not limited to, selecting a favorite of two images, answering simple multiple choice questions or viewing and rating a short video. You earn savings each time you complete a experience with the selected brand(s). You are offering your opinion about the advertising presented to you, not about the product itself.",
        ]
    },
    {
        header: "How do I load Downtime Dollars to my TheFreshGrocer Price Plus Club card?",
        body: [
            "Downtime Dollars savings can be loaded to your TheFreshGrocer Price Plus Club card at pre-defined value tiers - $1, $3, $6, or $9. Once you reach each tier, a button will activate on the site allowing you to choose to load savings to your card or keep earning until the next tier. For example, if you earn $1 and do not load it to your card and keep earning, when you reach $3, $6, or $9, you can then choose to add to your card.",
            "Please note: once savings are added to your card, you will see the expiration date on the screen. The savings will no longer be available after the date listed.",
            "Also, once you load the savings to your card (no matter the tier), you MUST redeem those savings before you can load additional savings.",
            "Remember: you CAN keep earning savings with Downtime Dollars, you just can’t load them to your card until you use the savings already loaded.",
        ]
    },
    {
        header: "Where can I check the status of Downtime Dollars earned?",
        body: [
            "From the main Downtime Dollars screen, tap on the card icon in the top right hand corner of your screen. This will navigate you to an Account screen, which provides information on a) earnings loaded to your TheFreshGrocer Price Plus Club card that is ready to spend, or b) progress towards your next $3, $6, or $9 earning tier.",
        ]
    },
    {
        header: "How much money can I earn on the app?",
        body: [
            "The total savings available will vary week to week. The total savings you can earn at any given time appears at the top of the home (or “Earn”) screen. The savings you can earn from each specific advertiser appears at the bottom of each experience tile on the main feed.",
        ]
    },
    {
        header: "Do Downtime Dollars that I have loaded to my TheFreshGrocer Price Plus Club card expire?",
        body: [
            "Redemption periods for all Downtime Dollars earnings tiers are 30-60 days once they are loaded to your Price Plus Club card. The expiration date will be clearly displayed underneath the card image on the Downtime Dollars account screen.",
        ]
    },
    {
        header: "How are my savings redeemed?",
        body: [
            "Be sure you’ve loaded your savings to your Price Plus Club card before your TheFreshGrocer purchase. Then, present your TheFreshGrocer Price Plus Club card at checkout. Your Downtime Dollars savings balance will be applied to your current purchases and automatically deducted from your order total. Savings are not tied to specific products. *Please note: You need to spend a $1.00 more than your Downtime Dollars reward in order to redeem.",
        ]
    },
    {
        header: "Can I use my savings on TheFreshGrocer from Home orders?",
        body: [
            "Yes! Downtime Dollars can be applied to your TheFreshGrocer from Home orders like any other savings tool.",
        ]
    },
    {
        header: "Do Downtime Dollars earnings only apply to the brands with whom I've connected and interacted?",
        body: [
            "The money you have earned may be applied to any subsequent shopping trip you make at TheFreshGrocer stores or via TheFreshGrocer from Home, and will be applied to your order regardless of what is in your shopping basket as long as your order total is greater than your Downtime Dollars Savings, and you have not purchased excluded items.",
            "<strong>(see below for list of excluded items)</strong>",
        ]
    },
    {
        header: "Are any items excluded from Downtime Dollars Savings?",
        body: [
            "Yes! Downtime Dollars may not be used towards the purchase of prescription medications, gift cards, gift certificates, postage stamp sales, money orders, money transfers, lottery tickets, bus tickets, fuel and metro passes, as well as milk, cigarettes, tobacco products and alcoholic beverages or any other items prohibited by law. Terms and conditions apply.",
        ]
    },
    {
        header: "Why don’t I see the products in Downtime Dollars in my local TheFreshGrocer?",
        body: [
            "Some of the products in Downtime Dollars are in development and may not be currently available for purchase.",
        ]
    },
    {
        header: "While completing a survey/watching a video/answering questions, I left the site. Now I can’t seem to find the experience again. Why?",
        body: [
            "Savings experiences are available on Downtime Dollars for different lengths of time – this is decided by the manufacturer. That specific experience you are looking for may have expired. We apologize for any inconvenience. However, we have many other experiences in Downtime Dollars that offer savings, with new ones added frequently. Please check back often!",
        ]
    },
  {
    header: "Why am I still seeing experiences that I have already completed?",
    body: [
      "Downtime Dollars experiences may now include links to recipes, digital coupons and ShopRite from Home. To ensure convenient access to those links, experiences will remain in your feed for 30 days after you've completed them but you will only be paid once per experience; any subsequent visits to these experiences will not result in additional earnings.",
    ]
  },
    {
        header: "What browsers can I use for Downtime Dollars?",
        body: [
            "<li>Internet Explorer 11</li>",
            "<li>Edge Versions 12+</li>",
            "<li>Chrome Versions 58+</li>",
            "<li>Safari Version S10+</li>",
            "<li>FireFox Versions 53+</li>",
        ]
    },
    {
        header: "Who should I contact if I have issues or concerns with Downtime Dollars?",
        body: [
            "For assistance with the Downtime Dollars, please contact 1-800-TheFreshGrocer."
        ]
    },
];

const DATA = () => {
    switch (RETAILER){
        case 'freshgrocer':
            return FRESHGROCER_FREQUENTLY_ASKED_QUESTIONS
        case 'shoprite':
            return SHOPRITE_FREQUENTLY_ASKED_QUESTIONS
        default:
            return []
    }
};

export default DATA();



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/FAQ/data.js